import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import dataLayerMiddleware from '@dc/data-layer/src';
import * as dataLayerUtils from '@dc/data-layer/src/utils.js';
import reducers from './ducks/reducers';
import { initGroupCallListener } from './groupCallListener';
import { initStorePersistence } from './storePersistence';
import browserHistory from './browserHistory';

function setGlobalAppState(appState) {
  if (window.appState === undefined) {
    Object.defineProperty(
      window,
      'appState',
      {
        get: function getAppState() {
          return appState;
        },
        configurable: true
      }
    );
  }
  return window.appState;
}

export default function initAppState(initialState) {
  if (window.digitalData === undefined) {
    window.digitalData = {};
  }

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle

  const appState = createStore(reducers, initialState, composeEnhancers(
    applyMiddleware(
      thunkMiddleware,
      dataLayerMiddleware(window.digitalData, dataLayerUtils.satelliteTrack)
    )
  ));

  initStorePersistence(appState);
  initGroupCallListener(appState);
  browserHistory.initOnPopStateHandler();

  return setGlobalAppState(appState);
}
